import React, { useEffect } from "react";
import Modal from "react-modal";
import {
  Container,
  ContentContainer,
  SelectionContainer,
  TitleContainer,
  ItemContainer,
  CheckboxContainer,
  BtnContainer,
  CancelIconContainer,
} from "./UsageTabletSettingModal.styles";
import UI from "@mile-meeting/mile-ui";
import Callout from "uis/Callout";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    maxHeight: `${window.innerHeight - 100}px`,
    width: "560px",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    padding: "0",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

Modal.setAppElement("#root");

type UsageTabletSettingModalProps = {
  modalIsOpen: boolean;
  closeModal: () => void;
  usageInternal?: boolean;
  usageExternal?: boolean;
  onSave?: (internal: boolean, external: boolean) => void;
};

const UsageTabletSettingModal: React.FC<UsageTabletSettingModalProps> = ({
  modalIsOpen,
  closeModal,
  usageInternal,
  usageExternal,
  onSave = () => {},
}) => {
  const [isCheckedInternal, setIsCheckedInternal] = React.useState(false);
  const [isCheckedExternal, setIsCheckedExternal] = React.useState(false);

  useEffect(() => {
    if (modalIsOpen) {
      setIsCheckedInternal(usageInternal ?? false);
      setIsCheckedExternal(usageExternal ?? false);
    }
  }, [modalIsOpen]);

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelIconContainer>
          <UI.IconButton.Normal icon="x" size={20} color="var(--alias-color-label-normal)" onClick={closeModal} />
        </CancelIconContainer>
        <TitleContainer>
          <UI.Typography type="heading02" fontStyle="bold" color="var(--alias-color-label-neutral)">
            회의실 태블릿 사용 설정
          </UI.Typography>
        </TitleContainer>
        <ContentContainer>
          <Callout context={"태블릿 사용 위치를 설정할 수 있습니다. 회의실 내부/외부 중복 선택이 가능합니다."} />
          <SelectionContainer>
            <ItemContainer onClick={() => setIsCheckedInternal(!isCheckedInternal)}>
              <CheckboxContainer>
                <UI.CheckBox selected={isCheckedInternal}  />
                <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
                  회의실 내부
                </UI.Typography>
              </CheckboxContainer>
              <UI.Typography
                type="label01"
                fontStyle="medium"
                color="var(--alias-color-label-alternative)"
                style={{ marginLeft: "32px" }}
              >
                <strong style={{ fontWeight: 700 }}>회의실 내부에 태블릿을 설치하여 사용합니다.</strong>
                <br />
                바로 예약, 연장, 남은 시간 확인 등 이용 편의 기능과 함께,
                <br />
                자동 체크인/체크아웃을 통해 효율적인 회의실 운영을 지원합니다.
              </UI.Typography>
            </ItemContainer>
            <ItemContainer onClick={() => setIsCheckedExternal(!isCheckedExternal)}>
              <CheckboxContainer>
                <UI.CheckBox selected={isCheckedExternal} />
                <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
                  회의실 외부
                </UI.Typography>
              </CheckboxContainer>
              <UI.Typography
                type="label01"
                fontStyle="medium"
                color="var(--alias-color-label-alternative)"
                style={{ marginLeft: "32px" }}
              >
                <strong style={{ fontWeight: 700 }}>회의실 외부에 태블릿을 설치하여 사용합니다.</strong>
                <br />
                실시간 회의실 이용 현황 확인 및 현장 바로 예약 등 이용 편의 기능을
                <br />
                제공합니다.
              </UI.Typography>
            </ItemContainer>
          </SelectionContainer>
          <BtnContainer>
            <UI.Button title="취소하기" type="outlined" size="large" style={{ width: "100%" }} onClick={closeModal} />
            <UI.Button
              title="설정하기"
              size="large"
              style={{ width: "100%" }}
              onClick={() => onSave(isCheckedInternal, isCheckedExternal)}
            />
          </BtnContainer>
        </ContentContainer>
      </Container>
    </Modal>
  );
};

export default React.memo(UsageTabletSettingModal);
